import { type ToastContent, type ToastOptions, toast } from "react-toastify";

// Shared defaults for every cashier toast. Per-type icons and colours are
// configured once on the <Toast> container (see Toast.tsx / Toast.module.css),
// so call sites only need the message and may override individual options.
const DEFAULT_OPTIONS: ToastOptions = {
  autoClose: 3000,
  theme: "colored",
  position: "bottom-right",
};

const withDefaults = (options?: ToastOptions): ToastOptions => ({
  ...DEFAULT_OPTIONS,
  ...options,
});

export const notify = {
  success: (content: ToastContent, options?: ToastOptions) =>
    toast.success(content, withDefaults(options)),
  error: (content: ToastContent, options?: ToastOptions) =>
    toast.error(content, withDefaults(options)),
  info: (content: ToastContent, options?: ToastOptions) =>
    toast.info(content, withDefaults(options)),
  warning: (content: ToastContent, options?: ToastOptions) =>
    toast.warning(content, withDefaults(options)),
};
